export default __webpack_public_path__ + "static/media/virtual.3189c1ef.jpeg";